// extracted by mini-css-extract-plugin
export var bigHeadline = "heroTeaser-module--bigHeadline--a1af9";
export var contentContainer = "heroTeaser-module--contentContainer--22637";
export var ctasContainer = "heroTeaser-module--ctasContainer--e4fe5";
export var halfHalf = "heroTeaser-module--halfHalf--c2e3c";
export var heroTeaser = "heroTeaser-module--heroTeaser--55260";
export var hl = "heroTeaser-module--hl--70e21";
export var isBlue = "heroTeaser-module--isBlue--acb4e";
export var isEditorial = "heroTeaser-module--isEditorial--10809";
export var leftAlign = "heroTeaser-module--leftAlign--c31c8";
export var leftTopMargins = "heroTeaser-module--leftTopMargins--c23b8";
export var link = "heroTeaser-module--link--62040";
export var secondCta = "heroTeaser-module--secondCta--88b61";
export var text = "heroTeaser-module--text--64de4";